import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const ASSIGN_NUMBERS_REQUEST = 'ASSIGN_NUMBERS_REQUEST';
export const ASSIGN_NUMBERS_FAILURE = 'ASSIGN_NUMBERS_FAILURE';
export const ASSIGN_NUMBERS_SUCCESS = 'ASSIGN_NUMBERS_SUCCESS';

/**
 * Issues a competition number to every entered athlete who has none.
 *
 * The backend decides everything — who is unnumbered, the order they are
 * numbered in, and what the next number is. This only asks. It returns
 * { issued, total } so the caller can say how many were given out without
 * counting anything itself.
 *
 * Safe to call again: it is idempotent server-side and can never move a
 * number that has already been issued.
 */
export const assignNumbers = (competitionId) => {
    return function(dispatch) {
        dispatch({ type: ASSIGN_NUMBERS_REQUEST });

        const options = apiRequestOptions(apiPath.COMPETITIONS.ASSIGN_NUMBERS, null, {
            params: { id: competitionId },
        });

        return axios(options)
            .then(transformHttpResponse)
            .then(response => {
                dispatch({ type: ASSIGN_NUMBERS_SUCCESS, result: response.data });
                return response.data;
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: ASSIGN_NUMBERS_FAILURE, error });
                dispatch(errorRequestHandler(error));
                throw error;
            });
    };
};
